













































import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({})
export default class CarStatus extends Vue {
  @Prop() public readonly statuses!: any

  public getClass(name: string) {
    if (this.statuses) {
      if (name === 'HEADLIGHTS' && this.statuses.hasOwnProperty('DIPPED_HEADLIGHTS') && this.statuses.FULL_BEAM_HEADLIGHTS === 'ON') {
        return 'car-status-blue'
      }
      if (name === 'HEADLIGHTS' && this.statuses.hasOwnProperty('DIPPED_HEADLIGHTS') && this.statuses.DIPPED_HEADLIGHTS === 'ON') {
        return 'car-status-green'
      }

      if (this.statuses.hasOwnProperty(name)) {
        if ((this.statuses as any)[name] === 'ON') {
          return 'car-status-red'
        } else {
          return 'car-status-green'
        }
      } else {
        return 'car-status-default'
      }
    }
  }
}
